<template>
  <div class="contents">
    <div class="header">
      <div class="header_left">
        <span>
          查询日期：
          <el-date-picker
            v-model="valueDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </span>

        <span>
          状态选择：
          <el-select v-model="StatusValue" clearable placeholder="请选择典当状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
        <span> 业务数量： {{ Total }} </span>
        <span>页数：{{ pagination }}</span>
      </div>

      <div class="header_right">
        <el-button type="primary" @click="QueryData">查询</el-button>
        <download-excel
          class="export-excel-wrapper"
          :data="tableData"
          :fields="json_fields"
          :name="
            title +
            '(' +
            StatusValue +
            ')' +
            '当品登记表' +
            pageNum +
            '-' +
            pagination +
            '.xls'
          "
        >
          <el-button type="primary" size="small">导出EXCEL</el-button>
        </download-excel>
      </div>
    </div>

    <!-- 内容栏 -->
    <div class="titles">{{ title }} 当品登记表</div>
    <div class="conte">
      <el-table
        :data="tableData"
        border
        max-height="850"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据正在从火星赶来,请等待..."
      >
        <el-table-column
          prop="stas"
          label="业务类型"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="xuday"
          label="发生时间"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.time !== undefined
                ? scope.row.xuday + " " + scope.row.time
                : scope.row.xuday
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ticketnumber"
          label="票号"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="name" label="当户" header-align="center" align="center">
        </el-table-column>
        <el-table-column
          prop="cardnumber"
          label="证件号"
          width="180"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="telnumber"
          label="电话"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="itemname"
          label="物品名称"
          width="180"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="pri" label="典当金额" header-align="center" align="center">
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量/g"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.weight !== undefined ? scope.row.weight : "未接入" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="overdate"
          label="开始日期"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="enddate"
          label="到期日期"
          width="130"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="agent" label="经办人" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="review" label="复核" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="finance" label="财务" header-align="center" align="center">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >确认</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="showPagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="Total"
          :page-size="1000"
          @current-change="paging"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "DpRegister",
  data() {
    return {
      valueDate: [],
      options: [
        {
          value: "建当",
          label: "建当",
        },
        {
          value: "续当",
          label: "续当",
        },
        {
          value: "赎当",
          label: "赎当",
        },
        {
          value: "绝当",
          label: "绝当",
        },
      ],
      StatusValue: "",
      tableData: [],
      loading: true,
      userData: "",
      ACCESS_TOKEN: "",
      dates: "",
      username: "",
      showPagination: false,
      Total: 0,
      TotalNum: 0,
      pagination: 1,
      title: "",

      json_fields: {
        业务类型: "stas",
        发生时间: "xuday",
        票号: "ticketnumber",
        当户: "name",
        证件号: "cardnumber",
        电话: "telnumber",
        物品名称: "itemname",
        "典当金额/元": "pri",
        "重量/g": "weight",
        开始日期: "overdate",
        到期日期: "enddate",
        经办人: "agent",
        复核: "review",
        财务: "finance",
      },

      pageNum: 1, //当前页码
    };
  },
  methods: {
    QueryData() {
      if (this.valueDate !== null && this.valueDate !== []) {
        this.title = this.valueDate[0] + " 至 " + this.valueDate[1];
        this.loading = true;
        //日期不为空，判断类型是否为空 //查询日期内的数据
        if (this.StatusValue !== "") {
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").where({xuday:_.gte("${this.valueDate[0]}").and(_.lte("${this.valueDate[1]}")),stas:_.eq("${this.StatusValue}")}).limit(100).get()`,
            })
            .then((res) => {
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              this.Total = res.data.pager.Total;

              this.tableData = res.data.data;
              this.loading = false;

              if (res.data.pager.Total > 1000) {
                this.showPagination = true;
              } else {
                this.showPagination = false;
              }
            });
          return;
        }
        //查询日期内和类型的数据

        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("yxus_record").where({xuday:_.gte("${this.valueDate[0]}").and(_.lte("${this.valueDate[1]}"))}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });

            this.Total = res.data.pager.Total;
            this.tableData = res.data.data;
            this.loading = false;
            if (res.data.pager.Total > 1000) {
              this.TotalNum = Math.ceil(res.data.pager.Total / 1000);
              this.pagination = Math.ceil(res.data.pager.Total / 1000);

              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
          });
      } else {
        this.$message.error("请选择日期进行查询");
      }
    },

    //默认查找
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({xuday:_.eq("${this.dates}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.tableData = res.data.data;
          this.Total = res.data.pager.Total;
          this.loading = false;
        });
    },
    handleClick(event) {
      this.$confirm(`确定客户：${event.name}的登记数据吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").doc("${event._id}").update({data:{finance:"${this.username}"}})`,
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.$notify({
                  title: "成功",
                  message: `客户：${event.name},财务确认成功`,
                  type: "success",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1000);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消确定",
          });
        });
    },

    //分页数据
    paging(e) {
      let ae = e - 1;
      let pags = ae * 100;
      this.loading = true;

      //日期有值
      if (this.valueDate !== null && this.valueDate !== []) {
        //状态有值

        if (this.StatusValue !== "") {
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").where({xuday:_.gte("${this.valueDate[0]}").and(_.lte("${this.valueDate[1]}")),stas:_.eq("${this.StatusValue}")}).limit(1000).skip(${pags}).get()`,
            })
            .then((res) => {
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });
              this.tableData = res.data.data;
              this.loading = false;
            });
          return;
        }
        //状态为空

        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("yxus_record").where({xuday:_.gte("${this.valueDate[0]}").and(_.lte("${this.valueDate[1]}"))}).limit(1000).skip(${pags}).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.tableData = res.data.data;
            this.loading = false;
          });
      } else {
        //日期为空

        this.$message.error("请选择日期进行查询");
      }
    },

    // this.
  },
  beforeCreate() {
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  created() {
    this.dates = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    this.title = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  },
  mounted() {
    setTimeout(() => {
      this.getData();
      this.username = this.userData.username;
    }, 1000);
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 180px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.header_left span {
  margin: 0 10px;
}
.conte {
  margin: 20px auto;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.header_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header_right button {
  margin: 10px 0;
}
.titles {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 10px 0;
}
</style>
